
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/visionaryholdings",
      function () {
        return require("private-next-pages/cases/visionaryholdings/index.tsx");
      }
    ]);
  